import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem, metrics } from '../../__styling'

const { neutral, uplate, section } = tokens.thenightly.colors.palette
const { md, lg } = metrics.thenightly.margins

interface StyledOptionItemProps {
    disabled?: boolean
    editable?: boolean
}

export const StyledOptionItem = styled('li')<StyledOptionItemProps>(
    ({ disabled, editable = true }) => ({
        padding: calcRem(md, 0),
        borderBottom: `0.5px solid ${neutral[20]}`,
        cursor: disabled ? 'not-allowed' : editable ? 'pointer' : 'default',
        '& > div': {
            display: 'flex',
            div: {
                flex: 1,
            },
        },

        div: {
            '&:value-wrapper': {
                paddingRight: calcRem(8),
            },
        },

        small: {
            fontSize: calcRem(12),
            fontWeight: 400,
            lineHeight: calcRem(16),
            color: neutral[70],
        },

        p: {
            margin: 0,
            fontWeight: 400,
            color: neutral[100],
            lineHeight: '150%',

            wordBreak: 'break-word',
        },

        span: {
            display: 'flex',
            alignItems: 'center',
            color: disabled ? neutral[30] : uplate.default,
            svg: {
                marginLeft: calcRem(5),
            },
        },

        a: {
            color: section.opinion[30],
        },
    }),
)

export const StyledManageAccount = styled('div')({
    ul: {
        listStyle: 'none',
        padding: 0,
        margin: calcRem(0, 0, lg, 0),
    },
})
